import { Outlet, createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { AppMain } from "../components/app-shell/AppMain";
import { AppNavSidebar } from "../components/app-shell/AppNavSidebar";
import { AppShell } from "../components/app-shell/AppShell";
import { AppShellBody } from "../components/app-shell/AppShellBody";

function AppRouteLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const onMenuAction = window.desktopBridge?.onMenuAction;
    if (typeof onMenuAction !== "function") {
      return;
    }

    const unsubscribe = onMenuAction((action) => {
      if (action !== "open-settings") return;
      void navigate({ to: "/settings" });
    });

    return () => {
      unsubscribe?.();
    };
  }, [navigate]);

  return (
    <AppShell>
      <AppShellBody>
        <AppNavSidebar />
        <AppMain>
          <Outlet />
        </AppMain>
      </AppShellBody>
    </AppShell>
  );
}

export const Route = createFileRoute("/_app")({
  component: AppRouteLayout,
});
